$(document).ready(function(){
    validateForm({
        formId: 'form-mortgage'
        //formValidClass: 'Form_valid',
        //formInvalidClass: 'Form_invalid',
        //inputErrorClass: 'Input_error'
    });
});